import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownToHtmlPipe } from './markdown.pipe';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ MarkdownToHtmlPipe ],
    exports: [ MarkdownToHtmlPipe ],
})
export class MarkdownToHtmlPipeModule {}
